import { Component } from '@angular/core';
import { StatisticDay } from './supa-statistics.component';

@Component({
  selector: 'app-supa-statistics-day-popover',
  template: `
    <div *ngIf="day"
         class="p-20">
      <div>{{ day.date | date }}</div>
<!--      <div># Einträge {{ day.entryCount }}</div>-->
      <div># Zeichen {{ day.charCount }}</div>
    </div>
  `
})
export class SupaStatisticsDayPopoverComponent {
  day?: StatisticDay;
}
